import { useState } from "react";
import axios from "axios";
import { logout } from "../../utils/logout";

let isRedirecting = false;

const usePatch = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const token = JSON.parse(sessionStorage.getItem("userData"));
  const access_token = token ? token.access_token : null;
  const patchData = async (patchData) => {
    setError(null);
    try {
      setLoading(true);
      const response = await axios.patch(url, patchData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setData(response?.data);
    } catch (err) {
      // Handle 401 errors
      if (err.response?.status === 401 && !isRedirecting) {
        isRedirecting = true;
        logout();
      }
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, patchData };
};

export default usePatch;
